module.exports = __webpack_public_path__ + "img/energetic4.4980ea13.jpg";